@if (medium && medium.contentType && !medium.processing) {
  <div [ngSwitch]="true" class="text-center">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">{{medium.name}}</h5>
    <sb-button classes="close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </sb-button>
  </div>
  <div *ngIf="showCodecWarning" class="red font-weight-bold">
    {{ 'lang.globals.notSupportedCodec' | translate }}{{ medium?.format?.videoCodec?.split(' ')[0] }}
  </div>
  <img class="img-responsive" *ngSwitchCase="medium.contentType.indexOf('image') !== -1" [sbMedium]="medium"
       [still]="false" [noCache]="true" [noPreview]=true alt="{{medium.name}}"
  />
  <video class="img-responsive" *ngSwitchCase="medium.contentType.indexOf('video') !== -1" [sbMedium]="medium"
         [noCache]="true" [still]="false" [noPreview]=true controls autoplay></video>
  <audio *ngSwitchCase="medium.contentType.indexOf('audio') !== -1" [sbMedium]="medium" [noCache]="true" [still]="false"
         [noPreview]=true controls autoplay style="width:100%"></audio>
  <object *ngSwitchCase="medium.contentType.indexOf('application') !== -1" [sbMedium]="medium" [still]="false"
          [noCache]="true" [noPreview]=true height="500" style="width:100%;"></object>
  <label class="form-label" *ngSwitchCase="medium.contentType.indexOf('text') !== -1">
    <textarea [sbMedium]="medium" [still]="false" [noCache]="true" [noPreview]=true disabled
              style="width:100%;min-height: 250px;background: white;"></textarea>
  </label>
  <div *ngSwitchDefault>
    {{'lang.globals.notSupportedFiletype' | translate}}
  </div>
</div>
} @else {
  <div class="tw-flex tw-items-center tw-justify-center tw-p-8 tw-text-2xl tw-font-semibold">{{ 'lang.globals.noDataFound' |translate }}
  </div>
}
